import { render, staticRenderFns } from "./sendPriority.vue?vue&type=template&id=9d3390c8&scoped=true&"
import script from "./sendPriority.vue?vue&type=script&lang=js&"
export * from "./sendPriority.vue?vue&type=script&lang=js&"
import style0 from "./sendPriority.vue?vue&type=style&index=0&id=9d3390c8&scoped=true&lang=css&"
import style1 from "./sendPriority.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3390c8",
  null
  
)

export default component.exports